import { useDeferredMount } from '@timelyapp/react';
import classNames from 'classnames';
import React from 'react';
import { prefixHexColor } from 'utils/colors';
import styles from './GanttChart.module.scss';
import type { Props } from './GanttChartTask';
import GanttChartTask from './GanttChartTask';

/**
 * Mount is expensive for the full task. Defer mounting until idle
 */
const GanttChartTaskDeferred = React.memo((props: Props) => {
  const { task, ...position } = props.taskWithLayout;

  const renderLightweight = useDeferredMount();

  if (renderLightweight) {
    return (
      <div
        className={classNames(styles.task)}
        style={{
          background: prefixHexColor(
            task.type === 'user'
              ? task.displayColor
              : props.ganttRow.type === 'project'
                ? props.ganttRow.displayColor
                : '333333'
          ),
          ...position,
        }}
      />
    );
  }
  return <GanttChartTask {...props} />;
});

GanttChartTaskDeferred.displayName = 'GanttChartTaskDeferred';

export default GanttChartTaskDeferred;
